import { render, staticRenderFns } from "./NormalCall.vue?vue&type=template&id=0398fa62&scoped=true&"
import script from "./NormalCall.vue?vue&type=script&lang=js&"
export * from "./NormalCall.vue?vue&type=script&lang=js&"
import style0 from "./NormalCall.vue?vue&type=style&index=0&id=0398fa62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0398fa62",
  null
  
)

export default component.exports